import { apiResponseMiddleware } from "@/middleware/api-response";
import toast from "react-hot-toast";

import { CategoryType } from "@/types/category";

import { api } from "./axios-instance";
import { config } from "@/config/base";

const API_ENDPOINT = "/api/Category";

export const getAllCategories = async ({
  page,
  size,
  search
}: {
  page: number;
  size: number;
  search?: string;
}) =>
  await apiResponseMiddleware<CategoryType[]>(
    api.get(`${API_ENDPOINT}/all`, {
      params: {
        pageSize: size,
        pageNumber: page,
        search: search || ""
      }
    }),
    () => {},
    { showToast: false }
  );

export const createCategory = async (data: Partial<CategoryType>) =>
  await apiResponseMiddleware<CategoryType>(
    api.post(`${API_ENDPOINT}/create`, data),
    () => {
      toast.success(config.appConfig.messages.categoryCreated, {
        id: "api-middleware"
      });
    },
    { showToast: true }
  );

export const editCategory = async (data: CategoryType) =>
  await apiResponseMiddleware<CategoryType>(
    api.post(`${API_ENDPOINT}/update`, data),
    () => {
      toast.success(config.appConfig.messages.categoryUpdated, {
        id: "api-middleware"
      });
    },
    { showToast: true }
  );

export const deleteCategory = async (categoryId: number) =>
  await apiResponseMiddleware<CategoryType>(
    api.post(`${API_ENDPOINT}/remove`, JSON.stringify(categoryId), {
      headers: {
        "Content-Type": "application/json"
      }
    }),
    () => {
      toast.success(config.appConfig.messages.categoryDeleted, {
        id: "api-middleware"
      });
    },
    { showToast: true }
  );

export const updateFormCategories = async (
  formId: number,
  categoryIds: number[]
) =>
  await apiResponseMiddleware(
    api.post(`/api/Form/${formId}/categories`, categoryIds),
    () => {},
    { showToast: false }
  );

export const updateRoleCategories = async (
  roleId: number,
  categoryIds: number[]
) =>
  await apiResponseMiddleware(
    api.post(`/api/Role/${roleId}/categories`, categoryIds),
    () => {},
    { showToast: false }
  );

export const updateEntityCategories = async (
  entityId: number,
  categoryIds: number[]
) =>
  await apiResponseMiddleware(
    api.post(`/api/Entity/${entityId}/categories`, categoryIds),
    () => {},
    { showToast: false }
  );

export const updateWorkflowCategories = async (
  workflowId: number,
  categoryIds: number[]
) =>
  await apiResponseMiddleware(
    api.post(`/api/WorkFlow/${workflowId}/categories`, categoryIds),
    () => {},
    { showToast: false }
  );

export const updateMenuElementCategories = async (
  menuElementId: number,
  categoryIds: number[]
) =>
  await apiResponseMiddleware(
    api.post(`/api/MenuElement/${menuElementId}/categories`, categoryIds),
    () => {},
    { showToast: false }
  );
